import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export function QlfPlaceholderIcon(props: FontAwesomeIconProps) {
  return (
    <FontAwesomeIcon color="lightgrey" size="10x" {...props} style={{ marginBottom: '40px' }} />
  );
}
